import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 50px 40px;
  align-items: center;
  gap: 0.4rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.hoverGray};
  }

  > img {
    width: 100%;
    max-width: 80px;
    max-height: 80px;
    min-width: 80px;
    min-height: 80px;
    object-fit: contain;
  }

  > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Quantity = styled.div`
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20%;
  margin: 0 auto;
`;

export const AreaTitlePart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;

  &&& {
    > div:first-child {
      padding-left: 6px;
    }

    .text-with-icon .text {
      display: block;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .supplierInventoryPartName .partName .text-content {
      display: block;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .MuiFormControl-root {
      border-radius: 4px;
    }

    .MuiInputBase-root {
      border: 1px solid ${({ theme }) => theme.grayDark};
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 2px;
    }
  }
`;
